<nav class="navbar navbar-expand-lg navbar-light mb-5">
    <div class="container-fluid">
      <img *ngIf="ThemeService.getThemes() == 'light'"  src="https://s3.eu-north-1.amazonaws.com/menuload.com/app/logo.webp" class="logo"/>
      <img *ngIf="ThemeService.getThemes() == 'dark'" src="https://s3.eu-north-1.amazonaws.com/menuload.com/app/logo-dark.webp" class="logo"/>
      <img 
          *ngIf="ThemeService.getThemes() === 'system'" 
          [src]="isSystemDark ? 'https://s3.eu-north-1.amazonaws.com/menuload.com/app/logo-dark.webp' : 'https://s3.eu-north-1.amazonaws.com/menuload.com/app/logo.webp'" 
          class="logo"/>
   
        <div class="d-flex align-items-center">
  
            <app-change-themes class="mx-3" [isName]="false"></app-change-themes>
  
  
            <ng-template #content let-modal>
              <div class="modal-header">
                <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
              </div>
              <div class="modal-body">
                <app-change-language></app-change-language>
              </div>
              
            </ng-template>
            
            <button class="btn-lang border" (click)="open(content)">
              <img *ngIf="selectedLanguage?.img" class="rounded" [src]="selectedLanguage.img" alt="{{selectedLanguage.name}}" >
              {{ selectedLanguage?.name || 'Language' }}
            </button>
            
  
        </div>
  
    </div>
</nav>